export const CONFIRM_LOCATION         = '@@locationExpiry/CONFIRM_LOCATION';
export const CONFIRM_LOCATION_SUCCESS = '@@locationExpiry/CONFIRM_LOCATION_SUCCESS';
export const CONFIRM_LOCATION_ERROR   = '@@locationExpiry/CONFIRM_LOCATION_ERROR';
export const CANCEL_CONFIRM_LOCATION  = '@@locationExpiry/CANCEL_CONFIRM_LOCATION';

export const confirmLocation = (locationId) => ({
  type: CONFIRM_LOCATION,
  locationId
});

export const confirmLocationSuccess = (location) => ({
  type: CONFIRM_LOCATION_SUCCESS,
  payload: location
});

export const confirmLocationError = (err) => ({
  type: CONFIRM_LOCATION_ERROR,
  payload: err
});
